/* =================== Rosy Nebula ==================*/
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Homepage from '../views/Homepage.vue'
import News from '../views/News.vue'
import AboutUs from '../views/AboutUs.vue'
import ContactUs from '../views/ContactUs.vue'
import PlanandCases from '../views/PlanandCases.vue'
import IndustryArea from '../views/IndustryArea.vue'

// ======================== NewsDetailPages ============================================
import News_001 from '../views/NewsDetailPages/001-CompanyEstablishedPage.vue'
import News_002 from '../views/NewsDetailPages/002-CeramsiteFactoryPage.vue'
import News_003 from '../views/NewsDetailPages/003-XiangShanPage.vue'
import News_004 from '../views/NewsDetailPages/004-LightShowpage.vue'
import News_005 from '../views/NewsDetailPages/005-IEBPage.vue'
import News_006 from '../views/NewsDetailPages/006-VRMusicPage.vue'
import News_007 from '../views/NewsDetailPages/007-InnovationEntrepreneurshipPage.vue'
import News_008 from '../views/NewsDetailPages/008-VRParkPage.vue'
import News_009 from '../views/NewsDetailPages/009-GlobalPitch2024.vue'
import News_010 from '../views/NewsDetailPages/010-VRParkFairyTale.vue'
import News_011 from '../views/NewsDetailPages/011-VRParkOrcaBeat.vue'
import News_012 from '../views/NewsDetailPages/012-CulturalExhibition.vue'


// ======================== CasesDetailPages ============================================
// FilmTelevision
import DreamWaterDetail from '../views/CasesDetailPages/FilmTelevision/DreamWaterPage.vue'
import WhiteSnakeDetail from '../views/CasesDetailPages/FilmTelevision/WhiteSnakePage.vue'
// CultureTour
import CityWallProjectionDetail from '../views/CasesDetailPages/CultureTour/CityWallProjectionPage.vue'
import VRParkCasesDetail from '../views/CasesDetailPages/CultureTour/VRParkCasesPage.vue'
import VRParkNingboScienceDetail from '../views/CasesDetailPages/CultureTour/VRParkNingboScience.vue'
// DigitalAssets
import BeijiaoDigitalMuseumDetail from '../views/CasesDetailPages/DigitalAssets/BeijiaoDigitalMuseumPage.vue'
import CeramsiteFactoryDetail from '../views/CasesDetailPages/DigitalAssets/CeramsiteFactoryPage.vue'
// AIGC
import AIDrawingPageDetail from '../views/CasesDetailPages/AIGC/AIDrawingPage.vue'
import BataHumanDetail from '../views/CasesDetailPages/AIGC/BataHumanPage.vue'
import VirtaulDressingDetail from '../views/CasesDetailPages/AIGC/VirtualDressingPage.vue'

/* =================== Rosy Nebula ==================*/
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: Homepage
  },
  {
    path: '/news',
    name: 'news',
    component: News
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: AboutUs
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: ContactUs
  },
  {
    path: '/planAndCases',
    name: 'planandCases',
    component: PlanandCases
  },
  {
    path: '/industryArea',
    name: 'industryArea',
    component: IndustryArea
  },

  /* =================== NEWS PAGES ==================*/
  {
    path: '/news/001-CompanyEstablishedPage',
    name: 'News_001',
    component: News_001
  },
  {
    path: '/news/002-CeramsiteFactoryPage',
    name: 'News_002',
    component: News_002
  },
  {
    path: '/news/003-XiangShanPage',
    name: 'News_003',
    component: News_003
  },
  {
    path: '/news/004-LightShowPage',
    name: 'News_004',
    component: News_004
  },
  {
    path: '/news/005-IEBPage',
    name: 'News_005',
    component: News_005
  },
  {
    path: '/news/006-VRMusicPage',
    name: 'News_006',
    component: News_006
  },
  {
    path: '/news/007-InnovationEntrepreneurshipPage',
    name: 'News_007',
    component: News_007
  },
  {
    path: '/news/008-VRParkPage',
    name: 'News_008',
    component: News_008
  },
  {
    path: '/news/009-GlobalPitch2024',
    name: 'News_009',
    component: News_009
  },
  {
    path: '/news/010-VRParkFairyTale',
    name: 'News_010',
    component: News_010
  },
  {
    path: '/news/011-VRParkOrcaBeat',
    name: 'News_011',
    component: News_011
  },
  {
    path: '/news/012-CulturalExhibition',
    name: 'News_012',
    component: News_012
  },

  /* ===================== PLAN AND CASES ===================== */
  // filmAndTelevision
  {
    path: '/planAndCases/filmAndTelevision/DreamWaterPage',
    name: 'VirtualProductionDetail',
    component: DreamWaterDetail
  },
  {
    path: '/planAndCases/filmAndTelevision/WhiteSnakePage',
    name: 'WhiteSnakeDetail',
    component: WhiteSnakeDetail
  },
  // cultureTour
  {
    path: '/planAndCases/cultureTour/CityWallProjectionPage',
    name: 'CityWalkProjectionDetail',
    component: CityWallProjectionDetail
  },
  {
    path: '/planAndCases/cultureTour/VRParkCasesPage',
    name: 'VRParkCasesDetail',
    component: VRParkCasesDetail
  },
  {
    path: '/planAndCases/cultureTour/VRParkNingboScience',
    name: 'VRParkNingboScienceDetail',
    component: VRParkNingboScienceDetail
  },
  // digitalAssets
  {
    path: '/planAndCases/digitalAssets/BeijiaoDigitalMuseumPage',
    name: 'BeijiaoDigitalMuseumDetail',
    component: BeijiaoDigitalMuseumDetail
  },
  {
    path: '/planAndCases/digitalAssets/CeramsiteFactoryPage',
    name: 'CeramsiteFactoryDetail',
    component: CeramsiteFactoryDetail
  },
  // AIGC
  {
    path: '/planAndCases/AIGC/AIDrawingPage',
    name: 'AIDrawingPageDetail',
    component: AIDrawingPageDetail
  },
  {
    path: '/planAndCases/AIGC/BataHumanPage',
    name: 'BataHumanDetail',
    component: BataHumanDetail
  },
  {
    path: '/planAndCases/AIGC/VirtualDressingPage',
    name: 'VirtualDressingPageDetail',
    component: VirtaulDressingDetail
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      const element = document.querySelector(to.hash);
      if (element instanceof HTMLElement) {
        return window.scrollTo({
          top: element.offsetTop - 100, // Adjust the offset value as needed
          behavior: 'smooth'
        });
      }
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
})

export default router
